import { apiClient } from '@/utils/axios'
import { dateToString } from '@/utils/helpers'

import type { PpvMessage, PpvTrackingCategory } from '../types'

interface GetPpvTrackingParams {
  creatorId: number
  from: Date
  to: Date
}

const getPpvTracking = async ({
  creatorId,
  from,
  to,
}: GetPpvTrackingParams): Promise<Array<PpvTrackingCategory>> => {
  const response = await apiClient.get(
    `/creator/${creatorId}/tracking/script?from=${dateToString(
      from,
    )}&to=${dateToString(to)}`,
  )

  return response.data.categories
}

interface GetPpvTrackingMessagesParams {
  creatorId: number
  from: Date
  to: Date
  categoryIndex: number
  mediaSetIndex: string
  limit: number
  page: number
}

const getPpvTrackingMessages = async ({
  creatorId,
  from,
  to,
  categoryIndex,
  mediaSetIndex,
  page,
  limit,
}: GetPpvTrackingMessagesParams): Promise<Array<PpvMessage>> => {
  const response = await apiClient.get(
    `/creator/${creatorId}/tracking/script/messages/${categoryIndex}/${mediaSetIndex}/?from=${dateToString(
      from,
    )}&to=${dateToString(to)}&page=${page}&limit=${limit}`,
  )

  return response.data
}

export const ppvTrackingService = {
  getPpvTracking,
  getPpvTrackingMessages,
}
